import React, { Component, Fragment } from 'react';
import { Button, Header, Icon, Loader, Popup, Tab, Table } from 'semantic-ui-react';
import TableRow from '../../../Admin/CreateCourse/TableRow';
import moment from 'moment';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment';
import { IconHeader } from '../../util/css';
import {
    fetchCantons,
    fetchCountries, fetchDisabledAccesses,
    fetchEntities,
    fetchMunicipalities,
    fetchOrganizationalUnits, fetchRightTypes
} from '../../Lookups/util';
import { formatListForDropdownOptions } from '../../util/util';
import { Redirect } from 'react-router-dom';

class EditProperty extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            orgUnitsOptions: [],
            municipalitiesOptions: [],
            cantonsOptions: [],
            entitiesOptions: [],
            countriesOptions: [],
            rightTypesOptions: [],
            disabledAccessesOptions: [],

            orgUnitProperty: JSON.parse(localStorage.getItem('orgUnitProperty')).property.id,
            orgUnit: JSON.parse(localStorage.getItem('orgUnitProperty')).organizationalUnit.id,
            property: JSON.parse(localStorage.getItem('orgUnitProperty')).property.name,
            street: JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.street,
            place: JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.name,
            municipality: JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.municipality.id,
            canton: JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.canton.id,
            entity: JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.entity.id,
            country: JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.country.id,
            disabledAccess: JSON.parse(localStorage.getItem('orgUnitProperty')).disabledAccess.id,
            rightType: JSON.parse(localStorage.getItem('orgUnitProperty')).rightType.id,
            usefulSurface: JSON.parse(localStorage.getItem('orgUnitProperty')).usefulSurface,
            teachingArea: JSON.parse(localStorage.getItem('orgUnitProperty')).teachingArea,

            organizationalUnitPropertyOptLock: JSON.parse(localStorage.getItem('orgUnitProperty')).optLock,
            propertyOptLock: JSON.parse(localStorage.getItem('orgUnitProperty')).property.optLock,

            loading: true

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.editProperty = this.editProperty.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        axios.all([fetchOrganizationalUnits(), fetchMunicipalities(), fetchCantons(), fetchEntities(), fetchCountries(), fetchRightTypes(), fetchDisabledAccesses()])
            .then(axios.spread((orgUnitsRes, municipalitiesRes, cantonsRes, entitiesRes, countriesRes, rightTypesRes, disabledAccessesRes) => {
                const orgUnits = formatListForDropdownOptions(orgUnitsRes.data);
                const municipalities = formatListForDropdownOptions(municipalitiesRes.data);
                const cantons = formatListForDropdownOptions(cantonsRes.data);
                const entities = formatListForDropdownOptions(entitiesRes.data);
                const countries = formatListForDropdownOptions(countriesRes.data);
                const rightTypes = formatListForDropdownOptions(rightTypesRes.data);
                const disabledAccesses = formatListForDropdownOptions(disabledAccessesRes.data);

                const lookups = {
                    orgUnits,
                    municipalities,
                    cantons,
                    entities,
                    countries,
                    rightTypes,
                    disabledAccesses,
                };

                this.setState({
                    orgUnitsOptions: orgUnits,
                    municipalitiesOptions: municipalities,
                    cantonsOptions: cantons,
                    entitiesOptions: entities,
                    countriesOptions: countries,
                    rightTypesOptions: rightTypes,
                    disabledAccessesOptions: disabledAccesses,
                    loading: false
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch lookup data.', err);
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleChange(keyName, value) {
        this.setState({
            [keyName]: value
        });
    }

    editProperty() {
        const propertyPutRequest = {
            id: this.state.orgUnitProperty,
            optLock: this.state.organizationalUnitPropertyOptLock,
            organizationalUnit: { id: this.state.orgUnit },
            property: {
                id: this.state.orgUnitProperty,
                optLock: this.state.propertyOptLock,
                name: this.state.property,
                address: {
                    street: this.state.street,
                    place: {
                        name: this.state.place,
                        municipality: this.state.municipality ? { id: this.state.municipality } : null,
                        canton: this.state.canton ? { id: this.state.canton } : null,
                        entity: this.state.entity ? { id: this.state.entity } : null,
                        country: this.state.country ? { id: this.state.country } : null,
                    }
                },
                disabledAccess: this.state.disabledAccess ? { id: this.state.disabledAccess } : null,
            },
            rightType: this.state.rightType ? { id: this.state.rightType } : null,
            usefulSurface: this.state.usefulSurface,
            teachingArea: this.state.teachingArea,
            disabledAccess: this.state.disabledAccess ? { id: this.state.disabledAccess } : null,
            active: 1
        };
        axios.put('/assets/organizational-unit-properties/', { ...propertyPutRequest })
            .then(res => {
                // if (this.state.showFiltersOnButton) {
                //     this.getFilteredOrganizationalUnitProperties(this.state.activePage - 1, this.state.resultsPerPage);
                // } else {
                //     this.getOrganizationalUnitProperties(this.state.activePage - 1, this.state.resultsPerPage);
                // }
                toast('Zahtjev uspješno uređen!');
                this.setState({ return: true });
                // this.resetValues(null);
            })
            .catch(err => {
                console.log(err);
                if (err.response.data === 'Some arguments are invalid.') {
                    toast('Podaci nisu ispravni!');
                } else {
                    toast('Došlo je do greške prilikom uređivanja nepokretne imovine!');
                }
                // toast('Došlo je do greške prilikom uređivanja nepokretne imovine!');
            });
    }

    render() {
        if (this.state.return) {
            return <Redirect push to={{ pathname: '/imovina/nepokretna-imovina' }} />;
        }
        return (
            // eslint-disable-next-line react/jsx-no-undef
            <div>
                <Header as="h1">Nepokretna imovina</Header>
                <Segment.Group raised>
                    {/* eslint-disable-next-line react/jsx-no-undef */}
                    <Segment>
                        <Header as="h3">Izmjena imovine: {JSON.parse(localStorage.getItem('orgUnitProperty')).property.name}

                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={() => window.history.go(-1)} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    {this.state.loading ?
                        <Segment>
                            <Loader active inline="centered" />
                        </Segment>
                        : <Segment clearing>
                            <Table celled unstackable compact >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign="left" style={{ fontSize: '17px' }}>
                                        Trenutni podaci
                                        </Table.HeaderCell>
                                        <Table.HeaderCell style={{ fontSize: '17px' }}>
                                        Novi podaci
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    <TableRow
                                        disabled
                                        name="Organizaciona jedinica"
                                        keyName="orgUnit"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).organizationalUnit.name}
                                        onChange={this.handleInputChange}
                                        options={this.state.orgUnitsOptions}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).organizationalUnit.id}
                                    />
                                    <TableRow
                                        name="Ulica"
                                        keyName="street"
                                        onChange={this.handleChange}
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.street}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.street}
                                    />

                                    <TableRow
                                        name="Mjesto"
                                        keyName="place"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.name}
                                        onChange={this.handleChange}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.name}
                                    />

                                    <TableRow
                                        name="Općina"
                                        keyName="municipality"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.municipality.name}
                                        onChange={this.handleInputChange}
                                        options={this.state.municipalitiesOptions}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.municipality.id}
                                    />

                                    <TableRow
                                        name="Kanton"
                                        keyName="canton"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.canton.name}
                                        onChange={this.handleInputChange}
                                        options={this.state.cantonsOptions}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.canton.id}
                                    />

                                    <TableRow
                                        name="Entitet"
                                        keyName="entity"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.entity.name}
                                        onChange={this.handleInputChange}
                                        options={this.state.entitiesOptions}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.entity.id}
                                    />

                                    <TableRow
                                        name="Država"
                                        keyName="country"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.country.name}
                                        onChange={this.handleInputChange}
                                        options={this.state.countriesOptions}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).property.address.place.country.id}
                                    />

                                    <TableRow
                                        name="Naziv imovine"
                                        keyName="property"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).property.name}
                                        onChange={this.handleChange}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).property.name}
                                    />

                                    <TableRow
                                        name="Tip prava"
                                        keyName="rightType"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).rightType.name}
                                        onChange={this.handleInputChange}
                                        options={this.state.rightTypesOptions}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).rightType.id}
                                    />

                                    <TableRow
                                        name="Korisna površina (m²)"
                                        keyName="usefulSurface"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).usefulSurface}
                                        onChange={this.handleChange}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).usefulSurface}
                                    />

                                    <TableRow
                                        name="Površina površina (m²)"
                                        keyName="teachingArea"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).teachingArea}
                                        onChange={this.handleChange}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).teachingArea}
                                    />

                                    <TableRow
                                        name="Pristup invalidima"
                                        keyName="disabledAccess"
                                        value={JSON.parse(localStorage.getItem('orgUnitProperty')).disabledAccess.name}
                                        onChange={this.handleInputChange}
                                        options={this.state.disabledAccessesOptions}
                                        defValue={JSON.parse(localStorage.getItem('orgUnitProperty')).disabledAccess.id}
                                    />
                                </Table.Body>
                            </Table>
                            <Button
                                floated="right"
                                color="blue"
                                basic="true"
                                // disabled={localStorage.getItem('finalized')}
                                onClick={() => window.history.go(-1)}
                            >
                            Odustani
                            </Button>
                            <Button
                                floated="right"
                                color="blue"
                                // disabled={localStorage.getItem('finalized')}
                                onClick={this.editProperty}
                            >
                            Sačuvaj izmjene
                            </Button>
                        </Segment>}

                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default EditProperty;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Details/EditProperty.js